import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const containerStyles = xcss({
	display: 'flex',
	gap: 'space.100',
	paddingTop: 'space.100',
});

const filterStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
	backgroundColor: 'color.background.accent.gray.subtlest',
	borderRadius: 'radius.small',
	height: 'size.300',
	width: 'size.600',
});

export const LoadingFilters = (): React.JSX.Element => {
	return (
		<Box xcss={containerStyles}>
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
		</Box>
	);
};
